import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './FormFooter.styles';

export interface FormFooterProps {
  pending?: boolean;
  isDirty?: boolean;
  photoLoading?: boolean;
}

export function FormFooter({
  pending,
  isDirty,
  photoLoading
}: FormFooterProps) {
  const t = useTranslations('review.form');
  const slots = styles();

  return (
    <div className={slots.base()}>
      <UiKitButtonBase
        color="secondary"
        disabled={pending || !isDirty || photoLoading}
        className={slots.button()}
        type="submit"
      >
        {t('sendReview')}
      </UiKitButtonBase>

      <p className={slots.disclaimer()}>
        {t.rich('privacy', {
          buttonText: t('sendReview'),
          link: (chunks) => (
            <a
              className={slots.link()}
              href="/help/policy/"
              target="_blank"
              rel="noreferrer"
            >
              {chunks}
            </a>
          )
        })}
      </p>
    </div>
  );
}
